

































import { Component, Vue, Prop, Inject } from 'vue-property-decorator';
import AppToolbar from './toolbar/AppToolbar.vue';
import MenuItem from '@pjn/core/model/app/MenuItem';
import { BooleanProp, OptionalProp } from '@pjn/vue-core/component';

/**
 * Pagina de la aplicacion (raiz de una ruta).
 * Incluye el toolbar y el contenido
 */
@Component({ components: { AppToolbar } })
export default class PageView extends Vue {

  /** [Mobile] Titulo de la toolbar */
  @Prop() title: string;

  /** Prefijo a Mostrar antes del titulo */
  @Prop({default: 'PJN'}) preTitle: string;

  /** Indica si se muestra el titulo tambien en desktop */
  @BooleanProp(false) forceTitle: boolean;

  /** Oculta la toolbar */
  @BooleanProp(false) hideToolbar: boolean;

  /** [Mobile] Muestra el boton Back en lugar del menu lateral  */
  @BooleanProp(false) showBack: boolean;

  /** [Desktop] Comprime la altura  de la toolbar (default true) */
  @BooleanProp(true) toolbarDense: boolean;

  /** [Mobile] Comprime la altura  de la toolbar (default false) */
  @Prop({type: Boolean, default: false}) toolbarDenseMobile: boolean;

  /** Extiende la altura de la Toolbar para que tenga dos niveles. */
  @BooleanProp(false) toolbarExtended: boolean;

  /** Altura de la extension */
  @OptionalProp({type: [Number, String]}) extensionHeight: number | string;

  /** Remueve la sombra de la toolbar */
  @BooleanProp(false) toolbarFlat: boolean;

  /** Centra verticalmente el contenido */
  @BooleanProp(false) verticalCenter: boolean;

  /** Centra horizontalmente el contenido */
  @BooleanProp(true) horizontalCenter: boolean;

  /** Ocupa el 100% de la altura */
  @BooleanProp(true) fillHeight: boolean;

  private get padding() {
    if (!this.$mobile) return '';
    return `padding: ${this.toolbarDense ? '40' : '48'}px 0px 0px`;
  }

  private get titleToUse() {
    return (this.$mobile || this.forceTitle) ? this.title : undefined;
  }
}
